import ShareModal from './share-modal';
import './share-modal.less';

export default ShareModal;
